import PropTypes from "prop-types";
import { useEffect } from "react";
import styles from "./styles";
import { generateAppStoreLinks } from "../../utilities/app.js";
import Description from "../description-container";

export default function Hero({ imageLinksDesktop, imageLinksMobile }) {
  useEffect(() => {
    generateAppStoreLinks();
  }, []);

  return (
    <section className={styles.container}>
      <Description />
      <div className={styles.imageWrap}>
        {imageLinksMobile && imageLinksDesktop && (
          <picture className={styles.image}>
            <source
              srcSet={imageLinksMobile || ""}
              media="(max-width: 768px)"
            />
            <img
              className={styles.image}
              srcSet={imageLinksDesktop}
              alt="ASOS app"
            />
          </picture>
        )}
      </div>
    </section>
  );
}

Hero.propTypes = {
  imageLinksDesktop: PropTypes.string.isRequired,
  imageLinksMobile: PropTypes.string.isRequired,
};
